export type Result<T, E> = { type: 'Ok'; ok: T; err?: undefined } | { type: 'Err'; err: E; ok?: undefined };

export function resultMapOk<T, E, U>(result: Result<T, E>, mapFunc: (ok: T) => U): Result<U, E> {
  return result.type === 'Err' ? result : { type: 'Ok', ok: mapFunc(result.ok) };
}

export function resultAndThen<T, E, U>(result: Result<T, E>, mapFunc: (ok: T) => Result<U, E>): Result<U, E> {
  return result.type === 'Err' ? result : mapFunc(result.ok);
}

export function resultMapErr<T, E, U>(result: Result<T, E>, mapFunc: (err: E) => U): Result<T, U> {
  return result.type === 'Ok' ? result : { type: 'Err', err: mapFunc(result.err) };
}

export function wrapOk<T>(value: T) {
  return { type: 'Ok', ok: value } as const;
}

export function wrapErr<E>(value: E) {
  return { type: 'Err', err: value } as const;
}
